import { createApiConstants } from '@saucelabs/sl-util-redux';

export const createTestCaseTypes = (namespace) => {
  const createApiNamespacedConstants = createApiConstants.bind(null, namespace);

  return {
    INITIALIZED: `${namespace}/INITIALIZED`,
    CHANGE_PAGE: `${namespace}/CHANGE_PAGE`,
    RESET_PAGE: `${namespace}/RESET_PAGE`,
    CLEANUP: `${namespace}/CLEANUP`,
    CHANGE_SORTING: `${namespace}/CHANGE_SORTING`,
    UPDATE_TEST_OWNER: `${namespace}/UPDATE_TEST_OWNER`,
    GET_TESTS: createApiNamespacedConstants('GET_TESTS'),
    FETCH_USERS: createApiNamespacedConstants('FETCH_USERS'),
    FETCH_USER: createApiNamespacedConstants('FETCH_USER'),
    CHANGE_TRENDS_INTERVAL: `${namespace}/CHANGE_TRENDS_INTERVAL`,
    CHANGE_SELECTED_BAR: `${namespace}/CHANGE_SELECTED_BAR`,
    GET_TEST_CASES_TRENDS: createApiNamespacedConstants('GET_TEST_CASES_TRENDS'),
  };
};
